import React from 'react';
import { Carousel } from '@m4b-design/components';
import { ModuleContainer } from '@/containers/homepage-v2/carousel-module/module-container';
import { useCarouselModule } from '@/containers/homepage-v2/carousel-module/index.ViewHook';
import styles from './index.scss';
import cx from 'classnames';

interface CarouselModuleProps {
  className?: string;
}

export const CarouselModule = ({ className }: CarouselModuleProps) => {
  const { showModule, moduleArr, gridCols } = useCarouselModule();

  return showModule ? (
    <section className={cx(styles.container, className)}>
      <Carousel
        indicatorType="line"
        animation={'fade'}
        style={{ width: 1280 }}
        showArrow="hover">
        {moduleArr?.map((modules, index) => {
          return (
            <div className={`grid grid-cols-${gridCols} gap-16`} key={index}>
              {modules?.map(module => {
                return (
                  <ModuleContainer
                    key={module.module_config_id}
                    configId={module.module_config_id}
                    title={module.name}
                    articleList={module.learning_info}
                  />
                );
              })}
            </div>
          );
        })}
      </Carousel>
    </section>
  ) : null;
};
